import React from 'react';
import Tag from '@app/component/tag/Tag';
import _isEmpty from 'lodash/isEmpty';
import {
	useMarketStateTools,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useMarketStateTools';
import CalendarDay from '@app/state/calendar/CalendarDay';
import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';

const MarketStateSnapshotTableMedianFragment: React.FunctionComponent<{
	calendarDay: CalendarDay,
	roomMappingType?: HotelRoomMappingType
}> = ({ calendarDay, roomMappingType }) => {

	const tools = useMarketStateTools();
	const companyHotel = tools.companyHotel;

	if (!!tools.marketStateSnapshot && !_isEmpty(tools.marketStateSnapshot.dailySnapshots)) {
		const marketStateDailySnapshot = tools.marketStateSnapshot.findDailySnapshot(calendarDay.display);
		if (!!marketStateDailySnapshot) {
			const marketStateDailyHotelSnapshot = marketStateDailySnapshot.current.findDailyMainHotelSnapshot();
			if (!!marketStateDailyHotelSnapshot) {
				const median = roomMappingType ? marketStateDailySnapshot.current.evaluatePriceMedianForRoomType(companyHotel, roomMappingType)[0] : marketStateDailySnapshot.current.evaluatePriceMedian(companyHotel)[0];
				if (!!median && median.state != 'none')
					return <Tag state={median.state} title={median.value} extraClassName="max-w-full"><span className="truncate">{median.value}</span></Tag>
			}
		}

	}
	return <Tag state="none" title="Not Available">N/A</Tag>;
};

export default MarketStateSnapshotTableMedianFragment;